import { Type, type Static } from "@sinclair/typebox";
import { MatrixEventIdSchema } from "./agent-host.ts";

const PptExpertActivityEventBase = {
  version: Type.Literal("1.0"),
  sourceEventId: MatrixEventIdSchema,
  sequence: Type.Integer({ minimum: 1, maximum: 1_000_000 }),
  text: Type.String({ minLength: 1, maxLength: 256 })
};

export const PptExpertActivityPhaseSchema = Type.Union([
  Type.Literal("analyzing_materials"),
  Type.Literal("presentation_outline"),
  Type.Literal("drafting_presentation"),
  Type.Literal("checking_presentation"),
  Type.Literal("building_presentation"),
  Type.Literal("finalizing")
]);

export const PptExpertProgressEventSchema = Type.Object(
  {
    ...PptExpertActivityEventBase,
    type: Type.Literal("progress"),
    phase: PptExpertActivityPhaseSchema
  },
  { additionalProperties: false }
);

export const PptExpertToolEventSchema = Type.Object(
  {
    ...PptExpertActivityEventBase,
    type: Type.Literal("tool"),
    activityId: Type.String({
      minLength: 1,
      maxLength: 128,
      pattern: "^[A-Za-z0-9][A-Za-z0-9._:-]*$"
    }),
    tool: Type.String({ minLength: 1, maxLength: 64, pattern: "^[A-Za-z][A-Za-z0-9_]*$" }),
    status: Type.Union([
      Type.Literal("selected"),
      Type.Literal("started"),
      Type.Literal("completed"),
      Type.Literal("failed")
    ]),
    detail: Type.Optional(Type.String({ minLength: 1, maxLength: 256 })),
    durationMs: Type.Optional(Type.Integer({ minimum: 0, maximum: Number.MAX_SAFE_INTEGER }))
  },
  { additionalProperties: false }
);

export const PptExpertActivityEventSchema = Type.Union([
  PptExpertProgressEventSchema,
  PptExpertToolEventSchema
]);

export const PptExpertActivitySummarySchema = Type.Object(
  {
    events: Type.Array(PptExpertActivityEventSchema, { maxItems: 64 }),
    totalStepCount: Type.Optional(Type.Integer({ minimum: 0, maximum: 1_000_000 })),
    totalToolCallCount: Type.Optional(Type.Integer({ minimum: 0, maximum: 1_000_000 }))
  },
  { additionalProperties: false }
);

export type PptExpertActivityPhaseV1 = Static<typeof PptExpertActivityPhaseSchema>;
export type PptExpertProgressEventV1 = Static<typeof PptExpertProgressEventSchema>;
export type PptExpertToolEventV1 = Static<typeof PptExpertToolEventSchema>;
export type PptExpertActivityEventV1 = Static<typeof PptExpertActivityEventSchema>;
export type PptExpertActivitySummaryV1 = Static<typeof PptExpertActivitySummarySchema>;
